import React, { useEffect, useMemo, useState } from 'react';
import {
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CButton
} from '@coreui/react';
import PDFPreviewService from './PDFPreviewService';
import { blueButton } from 'src/utilities/CommonConstants';

const GlobalPDFPreviewModal = () => {
  const [state, setState] = useState({
    visible: false,
    doc: null,
    fileName: ''
  });

  // 🔹 Register ONCE
  useEffect(() => {
    PDFPreviewService.register(setState);
  }, []);

  const pdfUrl = useMemo(() => {
    if (!state.doc) return null;
    return URL.createObjectURL(state.doc.output('blob'));
  }, [state.doc]);

  const closeModal = () => {
    if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    setState(prev => ({ ...prev, visible: false }));
  };

  const downloadPdf = () => {
    if (!state.doc) return;
    state.doc.save(state.fileName);
  };

  // 🔍 DEBUG (remove later)
  console.log('PDF MODAL STATE:', state);

  return (
    <CModal
      visible={state.visible}
      size="xl"
      alignment="center"
      backdrop="static"
      // fullscreen={"xxl"}
      onClose={closeModal}
    >
      <CModalHeader closeButton={false} style={{gap: 10, justifyContent: 'flex-end'}}>
        <CButton color="secondary" onClick={closeModal}>
          Close
        </CButton>
        <CButton style={blueButton} onClick={downloadPdf}>
          Download
        </CButton>
      </CModalHeader>

      <CModalBody style={{ height: '70vh' }}>
        {pdfUrl ? (
          <iframe
            src={pdfUrl}
            title="PDF Preview"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
        ) : (
          <div>Loading preview…</div>
        )}
      </CModalBody>

      {/* <CModalFooter>
        <CButton color="secondary" onClick={closeModal}>
          Close
        </CButton>
        <CButton style={blueButton} onClick={downloadPdf}>
          Download
        </CButton>
      </CModalFooter> */}

    </CModal>
  );
};

export default GlobalPDFPreviewModal;
